import React from 'react'
import {
  BriefcaseIcon,
  CalendarIcon,
  LinkIcon,
  InformationCircleIcon
} from "@heroicons/react/20/solid";

export default function Header({ name, location, saveLocation }) {
  function formatDate(dateString) {
    if(!dateString) return '';
    const date = new Date(dateString);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  function toTitleCase(str = '') {
    return str.toLowerCase().replace(/\b\w/g, function(char) {
      return char.toUpperCase();
    });
  }

  return (
    <header className="bg-white shadow">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-6 pb-3">
        <h2 className="text-lg tracking-tight text-gray-400">Edit Location</h2>
        <h1 className="text-3xl font-bold tracking-tight text-gray-900">{name}</h1>
        <div className="mt-1 flex sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
          <div className="mt-2 flex items-center text-sm text-gray-500">
            <BriefcaseIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
            { location.chain?.name || "NONE" }
          </div>
          <div className="mt-2 flex items-center text-sm text-gray-500">
            <LinkIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
            {location.google_place_url ? (
              <a target="_blank" href={location.google_place_url}>
                View on Google Maps
              </a>
            ) : "No Google Place" }
          </div>
          <div className="mt-2 flex items-center text-sm text-gray-500">
            <InformationCircleIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
            { toTitleCase(location.status) }
          </div>
          <div className="mt-2 flex items-center text-sm text-gray-500">
            <CalendarIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
            Created on { formatDate(location.created_at) }
          </div>
          <button onClick={(e) => {
            e.preventDefault()
            saveLocation()
          }} className="save-location-button mt-2 flex ml-auto rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            Save
          </button>
        </div>
      </div>
    </header>
  )
}
